<template>
  <div class="wapper">
    <div class="query-wapper">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="客户账户名称"
            v-model="query.accountName"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="payTime"
            type="daterange"
            range-separator="至"
            start-placeholder="收付开始日期"
            end-placeholder="收付结束日期"   
            value-format="yyyy-MM-dd"  
            clearable>
         </el-date-picker>
        </el-col>
      </el-row>
      <el-row class="tips">注：请输入客户银行账户的完整名称进行查询</el-row>
      <div class="button-wapper">
        <el-button plain size="mini" @click="getPaymentList(undefined,1)"
          >查询</el-button
        >
        <el-button plain size="mini" @click="reset">重置</el-button>
        <el-button plain size="mini"   v-auth="'viewAll'"  @click="getPaymentAllList(undefined,2)">查询全量</el-button>
        <el-button plain size="mini"  v-auth="'timeLimit'"  @click="paymentDeadline">核款时限</el-button>
        <el-button plain size="mini"  v-auth="'verifyOuterOrderBatch'"  @click="verifyOuterOrder">批量核销外部订单</el-button>
      </div>
    </div>
  
    <div class="content-wapper">
      <el-tooltip placement="top-start">
          <div slot="content">1、在核款时限之前核销，且回款时间为本月前，归属账期为上月；<br/>2、在核款时限之后核销，或回款时间为本月，归属账期为本月；</div>
          <div class="tips times">核款时限：每月{{getVerifDeadlineData.verifDeadline}}号</div>
      </el-tooltip>
      <el-table :data="payInfos" size="mini" :border="true">
        <el-table-column
          prop="tradeNo"
          width="200"
          label="银行流水号"
        ></el-table-column>
        <el-table-column
          prop="flowCode"
          width="200"
          label="序列号"
        ></el-table-column>
        <el-table-column
          prop="payTime"
          width="150"
          label="收付时间"
        ></el-table-column>
        <el-table-column
          prop="describe"
          width="100"
          label="摘要"
        ></el-table-column>
        <el-table-column
          prop="accountName"
          width="150"
          label="客户账户名称"
        ></el-table-column>
        <el-table-column
          prop="contractAccountName"
          width="200"
          label="合约公司账户名称"
        ></el-table-column>
        <el-table-column prop="payName" width="100" label="收付款方式"></el-table-column>
        <el-table-column prop="bankName" label="银行名称"></el-table-column>
        <el-table-column
          prop="payAmount"
          width="110"
          label="收付金额"
        ></el-table-column>
        <el-table-column
          prop="verifyRemainTotal"
          width="110"
          label="待认领金额"
        ></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="300">
          <template slot-scope="scope">
            <el-button @click="handleOrdersClick(scope.row)" type="text" size="small"  v-auth="'verifyCrmOrder'">核销订单</el-button>
            <el-button type="text" size="small" @click="externalOrders(scope.row)"  v-auth="'verifyOuterOrder'">核销外部订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size="query.pageSize"
        @current-change="payCurrentChange"
        class="pagation"
        layout="prev, pager, next, jumper"
        :total="query.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="请设置每月核款时限："
      :before-close = "paymentDeadlineCanel"
      :visible.sync="paymentDeadlineDialog"
      width="30%"
      >
      <el-form  :model="getVerifDeadline" label-width="80px">
        <el-form-item label="输入时间：">
          <el-col :span="6">
            <el-input
              v-model.trim="getVerifDeadline.nextVerifDeadline"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              @change="handleInput"
            ></el-input>
          </el-col>
          <span>号</span>
        </el-form-item>
        <div class="tips paymentDeadlineTips">注：次月生效</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentDeadlineCanel">取 消</el-button>
        <el-button :disabled="paymentDeadlineBtn"   type="primary" @click="paymentDeadlineSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="请输入外部订单的核销信息："   :before-close = "verifyOuterOrderCanel" :visible.sync="verifyOuterOrderDialog">
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          fixed
          prop="orderNo"
          label="*订单编号"
          width="150">
          <template slot-scope="scope">
         <el-input v-model.trim="tableData[0].orderNo"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="activationTime"
          label="*开卡时间"
          width="200">
          <template slot-scope="scope">
            <el-date-picker
              style="width:175px"
              @change="activationTimeChange"
              v-model="tableData[0].activationTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="开卡时间"
              :clearable = "false"
              >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="*客户名称"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].customerName"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderTypeName"
          label="*订单类型"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].orderTypeName"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="refundOrderNo"
          label="关联退售单号"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].refundOrderNo"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="returnAmount"
          label="订单预计回款总额"
          width="300">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].returnAmount"> </el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="refundReturnAmount"
          label="订单退款总额"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].refundReturnAmount"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalUsableAmount"
          label="订单实际应回款总额"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].totalUsableAmount"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyAmount"
          label="*订单本次核销金额"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].verifyAmount" @change="verifyAmount" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,2})?.*$/,'$1')"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="ownerUserName"
          label="*核销销售"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].ownerUserName"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="ownerDepartmentName"
          label="*销售组别"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].ownerDepartmentName"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="*销售区域"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].companyName"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderCreatorName"
          label="售卡人"
          width="120">
          <template slot-scope="scope">
          <el-input v-model.trim="tableData[0].orderCreatorName"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="tips paymentDeadlineTips">注：本次核销归属账期为 {{tableData[0].collectionPeriod ? tableData[0].collectionPeriod : "xxxx"}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verifyOuterOrderCanel">取 消</el-button>
        <el-button    type="primary" @click="verifyOuterOrderSubmit">确认添加</el-button>
      </span>
    </el-dialog>
    <!-- 批量批量核销外部订单弹窗 -->
    <el-dialog title="批量核销外部订单" destroy-on-close :visible.sync="dialogCodeImport" width="50%">
        <div class="info">
            <span>温馨提醒</span>
            <span>1、上传导入文件必须是 .xls或 .xlsx格式</span>
            <span>2、请严格按照导入模板格式处理数据，确保上传的文档中无空格等特殊字符；</span>
        </div>
        <div class="one">
            <span>Step1：下载文档模板，按照要求处理数据</span>
            <el-button @click="getTemplatePath()" size="small">下载模板</el-button>
        </div>
        <div class="two">
            <span>Step2：导入处理好的数据文档</span>
            <input @change="fileChange($event)" type="file" ref="referenceUpload"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogCodeImport = false">取 消</el-button>
            <el-button type="primary" @click="verifysubmitImport()" :disabled='submitImport'>确认导入</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import _paymentService from "@/service/payment-inquiry-service";

export default {
  data() {
    return {
      payInfos: null,
      payTime: [],
      query: {
        accountName: "",
        payStartTime: "",
        payEndTime: "",
        systemId: 2,
        pageIndex: 1,
        pageSize: 20,
        total: 0,
      },
      paymentTypeList: null,
      paymentDeadlineDialog: false,
      getVerifDeadline: {
        id: "",
        nextVerifDeadline: ""
      },
      getVerifDeadlineData: {},
      paymentDeadlineBtn: false,
      verifyOuterOrderDialog: false,
      tableData: [{
          flowCode:'',
          activationTime:'',
          systemId:'',
          orderNo:'',
          refundOrderNo:'',
          customerName:'',
          orderTypeName:'',
          returnAmount:'',
          refundReturnAmount: '',
          totalUsableAmount: '',
          verifyAmount: '',
          ownerUserName: '',
          ownerDepartmentName: '',
          companyName: '',
          collectionPeriod:'',
          verifyRemainTotal:'',
          orderCreatorName:''
      }],
      queryCollectionPeriod:{
          flowCode:'',
          payTime:'',
          activationTime:''
      },
      typePage:'',
      dialogCodeImport: false,
      file: null,
      resultKey: '',
      submitImport: true
    }
  },
  mounted() {
     this.getPaymentType()
     this.getVerifDeadlineFun()
  },
  methods: {
    verifyOuterOrder() {
      this.dialogCodeImport = true
      this.submitImport = true
    },
    getTemplatePath() {
      _paymentService.getTemplate((res) => {
        console.log( res.orderVerifyTemplatePath);
          location.href = res.orderVerifyTemplatePath
      })
         
    },
    fileChange(e) {
       this.file = e.target.files[0]
       if (this.file) {
           this.submitImport = false
       }
    },
    verifysubmitImport() {

      let _loading = this.$loading({ fullscreen: true })
   
      _paymentService.verifyOuterOrderImport(
          this.file,
          (response) => {
              _loading.close()
              if (response.resultKey) {
                this.resultKey = response.resultKey
                this.getImportResult()
              }
          }, response => {
            this.$refs.referenceUpload.value = null;
            this.submitImport = true
              _loading.close()
              this.$notify({
                  message: response,
                  type: 'warning'
              })
      })
    },
    getImportResult() {
          let _loading = this.$loading({ fullscreen: true })
          _paymentService.getImportResult(
            {'resultKey' : this.resultKey},
            (response) => {

              _loading.close() 

              this.$notify({
                  message: '导入成功',
                  type: 'warning'
              })

              this.dialogCodeImport = false

            }, (response,data,code) => { 
    
              if (code == '-600006') {
                this.getImportResult(this.resultKey)
              } else if (code == '0'){
                _loading.close()
                this.dialogCodeImport = false
              } else{
                _loading.close()
                this.submitImport = true
                this.$notify({
                  message: response,
                  type: 'warning'
                })
              
                this.$refs.referenceUpload.value = null;
                
              }      
               
          })
    },
    verifyAmount(e){
     if (e == 0) {
      this.$notify({
          message: "不可为0",
          type: "warning",
        });
        return;
      }
    },
    activationTimeChange(value){
      console.log(value);
      if (value) {
         this.getQueryCollection()
      }
    },
    getPaymentType(){
      _paymentService.paymentTypeList({ state: 'CashFlowSourceEnum' }, (res) => {
          this.paymentTypeList = res;
      })
    },
    getQueryCollection() {
      this.queryCollectionPeriod.activationTime = this.tableData[0].activationTime
      _paymentService.getQueryCollectionPeriod(this.queryCollectionPeriod, (res) => {
          this.tableData[0].collectionPeriod = res.collectionPeriod;
      })
    },
    getPaymentList(pageIndex,typePage) {
      this.typePage = typePage
      if (pageIndex) this.query.pageIndex = pageIndex;
      else this.query.pageIndex = 1;

      if (this.payTime) {
        this.query.payStartTime = this.payTime[0];
        this.query.payEndTime = this.payTime[1]; 
      } else {
        this.query.payStartTime = "";
        this.query.payEndTime = "";
      }
      if (this.query.accountName == "" && this.payTime) {
        this.$notify({
          message: "客户账户名称不可为空",
          type: "warning",
        });
        return;
      }
      _paymentService.paymentList(
        this.query,
        (response, total) => {
          // 请求成功
          if (response) {
            this.payInfos = response;
          }
          this.query.total = total;
        },
        (response) => {
          this.$notify({
            message: response,
            type: "warning",
          });
          this.payInfos = null;
          this.query.pageIndex = 1;
          this.query.total = 0;
        }
      );
    },
    getPaymentAllList(pageIndex,typePage) {
      this.typePage = typePage
      if (pageIndex) this.query.pageIndex = pageIndex;
      else this.query.pageIndex = 1;

      if (this.payTime) {
        this.query.payStartTime = this.payTime[0];
        this.query.payEndTime = this.payTime[1]; 
      } else {
        this.query.payStartTime = "";
        this.query.payEndTime = "";
      }
      _paymentService.paymentAllList(
        this.query,
        (response, total) => {
          // 请求成功
          if (response) {
            this.payInfos = response;
          }
          this.query.total = total;
        },
        (response) => {
          this.$notify({
            message: response,
            type: "warning",
          });
          this.payInfos = null;
          this.query.pageIndex = 1;
          this.query.total = 0;
        }
      );
    },
    payCurrentChange(pageIndex) {
      if (this.typePage == 1) {
        this.getPaymentList(pageIndex);
      }else{
        this.getPaymentAllList(pageIndex);
      }
    },
    reset() {
      location.reload();
    },
    getVerifDeadlineFun () {
      _paymentService.getVerifDeadline(res => {
          this.getVerifDeadlineData = res;
          this.getVerifDeadline.id = res.id;
          this.$set(this.getVerifDeadline)
      })
    },
    paymentDeadline() {
      this.paymentDeadlineDialog = true
    },
    paymentDeadlineSubmit() {
      if (this.getVerifDeadline.nextVerifDeadline == "") {
        this.$notify({
          message: "输入时间",
          type: "warning",
        });
        return;
      }
      _paymentService.getEditVerifDeadline(this.getVerifDeadline, response => {
             this.$notify({
                    message: '成功',
                    type: 'success'
                })
              this.paymentDeadlineDialog = false
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
    },

    handleInput(value) {
      // 使用正则表达式来判断是否为1到28的正整数
      const regex = /^([1-9]|1[0-9]|2[0-8])$/;
      console.log(!regex.test(value),value);
      if (!regex.test(value)) {
        this.$notify({
            message: '请输入1-28号',
            type: 'warning'
        });
        this.paymentDeadlineBtn = true
      }else{
        this.getVerifDeadline.nextVerifDeadline = value
        this.$set(this.getVerifDeadline)
        this.paymentDeadlineBtn = false
      }
    },
    paymentDeadlineCanel() {
      this.paymentDeadlineDialog = false
      this.paymentDeadlineBtn = false
      this.getVerifDeadline.nextVerifDeadline = ''
      this.$set(this.getVerifDeadline)
    },
    externalOrders(row) {
      //this.getQueryCollection(row)
      this.queryCollectionPeriod.payTime = row.payTime
      this.queryCollectionPeriod.flowCode = row.flowCode
      this.tableData[0].flowCode = row.flowCode
      this.tableData[0].verifyRemainTotal = row.verifyRemainTotal

      if (this.$platform =='juyoufuli') {
        this.tableData[0].systemId = ""
      }else{
        this.tableData[0].systemId = this.query.systemId
      } 
   
      this.verifyOuterOrderDialog = true
      this.tableData[0].orderNo =''
      this.tableData[0].activationTime =''
      this.tableData[0].customerName =''
      this.tableData[0].orderTypeName =''
      this.tableData[0].verifyAmount =''
      this.tableData[0].ownerUserName =''
      this.tableData[0].ownerDepartmentName =''
      this.tableData[0].companyName =''
      this.tableData[0].refundOrderNo =''
      this.tableData[0].returnAmount =''
      this.tableData[0].refundReturnAmount =''
      this.tableData[0].totalUsableAmount =''
      this.tableData[0].orderCreatorName =''
      this.tableData[0].collectionPeriod=''
    },
    verifyOuterOrderCanel() {
      this.verifyOuterOrderDialog = false
      
    }, 
    verifyOuterOrderSubmit() {
      if (this.tableData[0].orderNo =='') {
        this.$notify({
                    message: '订单编号不能为空',
                    type: 'warning'
                })
        return
      }
      if (this.tableData[0].activationTime =='') {
        this.$notify({
                    message: '开卡时间不能为空',
                    type: 'warning'
                })
        return
      }
      if (this.tableData[0].customerName =='') {
        this.$notify({
                    message: '客户名称不能为空',
                    type: 'warning'
                })
        return
      }
      if (this.tableData[0].orderTypeName =='') {
        this.$notify({
                    message: '订单类型不能为空',
                    type: 'warning'
                })
        return
      }
      if (this.tableData[0].verifyAmount =='' || this.tableData[0].verifyAmount =='0') {
        this.$notify({
                    message: '订单本次核销金额不正确',
                    type: 'warning'
                })
        return
      }
      if (this.tableData[0].ownerUserName =='') {
        this.$notify({
                    message: '核销销售不能为空',
                    type: 'warning'
                })
        return
      }
      if (this.tableData[0].ownerDepartmentName =='') {
        this.$notify({
                    message: '销售组别不能为空',
                    type: 'warning'
                })
        return
      }
      if (this.tableData[0].companyName =='') {
        this.$notify({
                    message: '销售区域不能为空',
                    type: 'warning'
                })
        return
      }
      console.log((this.tableData[0].verifyAmount > this.tableData[0].verifyRemainTotal),this.tableData[0].verifyAmount,this.tableData[0].verifyRemainTotal);
      if (Number(this.tableData[0].verifyAmount) > Number(this.tableData[0].verifyRemainTotal)) {
        this.$notify({
                    message: '核销总金额大于当前流水剩余金额',
                    type: 'warning'
                })
        return
      }
      _paymentService.getVerifyOuterOrder(this.tableData[0], response => {
             this.$notify({
                    message: '添加成功',
                    type: 'success'
                })
            
              this.verifyOuterOrderDialog = false
          
              setTimeout(() => {
                this.$router.go(0)
              }, 500)
            
             
            }, response => {
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
    },
    handleOrdersClick(row) {
      if (this.$platform =='juyoufuli') {
        row['systemId'] = ""
      }else{
        row['systemId'] = this.query.systemId
      } 
    
      this.$set(row)
      
      this.$router.push({
          path: '/payment-inquiry-order',
          query: row
      })
    }

  }
};
</script>

<style scoped>
.wapper /deep/ .el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 12px;
}

.wapper /deep/.el-date-editor .el-range-input {
  width: 72%;
}
.tips {
  color: red;
}
.times {
  margin-bottom: 20px;
  width: 200px;
}
.times::before {
  font-family: element-icons !important;
  content: "\e7a4";
  color: #383E43;
}
.paymentDeadlineTips {
  margin-left: 10px;
}
.wapper {
  padding: 15px;
  display: flex;
  flex-direction: column;
  height: 100vh; 
  overflow: hidden; 
}

.header {
  margin-bottom: 15px;
}

.query-wapper {
  margin: 15px;
  padding: 15px;
  border: 1px solid #d6dbe5;
  position: relative;
  background: #fff;
  width: 100%;
}

.query-wapper::after {
  position: absolute;
  content: "筛选条件";
  top: -9px;
  color: #909399;
  background-color: #fbfbfb;
}

.content-wapper {
  padding: 0 15px;
  padding-bottom: 30px;
  flex: 1;
  width: 100%;
  overflow-y: scroll;
}

.button-wapper {
  margin-top: 10px;
}

.el-row {
  margin-bottom: 15px;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}
.info {
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid rgb(226, 226, 226);
    flex-direction: column;
}

.info span {
    margin-top: 0;
    color: #ff5e5e;
}

.info {
    background-color: #f8eec0;
    padding: 15px;
}

.info span:first-child {
    font-weight: bold;
    margin-bottom: 15px;
}
.one {
    font-weight: bold;
    margin-top: 20px;
}

.one span {
    margin-right: 20px;
}

.two {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top: 20px;
}

.two span:first-child {
    margin-right: 20px;
}
</style>
